import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";

import { WorkspaceDeletionImpactDocument } from "#app/lib/data";

/**
 * Live counts of what deleting the workspace removes. Always fresh from the
 * network: the number shown next to "Delete permanently" must be the number
 * that is about to be deleted, not a cached one.
 */
export function useWorkspaceDeletionImpact(workspaceId: string) {
  const variables = useMemo(() => ({ id: workspaceId }), [workspaceId]);
  const { data, loading } = useQuery(WorkspaceDeletionImpactDocument, {
    variables,
    fetchPolicy: "network-only",
  });
  const impact = data?.workspaceDeletionImpact ?? null;
  return { impact, initialLoading: loading && !impact };
}
